import { TableHeadersType } from "../../constant/tableHeadersConstants/tableHeadersType";
import { tableEditIcon } from "../../assets/images";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { formateDateTime } from "../../utils/commonFunctions";
import { CircularAvatar } from "../commons";
import { PaperClipIcon } from "../Icon";

type AppProps = {
  tableHeaders: TableHeadersType[] | [];
  data: any[] | [];
  handleEditHelpModule: (data: any) => void;
  handleOpenPreview:(data:any)=>void;
  isEditHelpDetailsPresent?:boolean;
 
};

const HelpModuleTable = ({
  tableHeaders,
  data,
  handleEditHelpModule,
  handleOpenPreview,
  isEditHelpDetailsPresent,
}: AppProps) => {

  return (
    <>
      {data?.length > 0 &&
        data?.map((helpModuleData: any) => {
          return (
            <tr className="text-left">
              {tableHeaders?.length > 0 &&
                tableHeaders?.map((header: TableHeadersType) => {
                  if (header?.value == "title") {
                    return (
                      <td
                        className="text-left"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {helpModuleData?.title?.length > 25 ? (
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 250 }}
                            overlay={
                              <Tooltip id="button-view">
                                {helpModuleData?.title}
                              </Tooltip>
                            }
                          >
                            <span>
                              {helpModuleData?.title
                                .toLowerCase()
                                ?.substr(0, 20) +
                                (helpModuleData?.title &&
                                helpModuleData?.title?.length > 20
                                  ? "..."
                                  : "")}
                            </span>
                          </OverlayTrigger>
                        ) : (
                          helpModuleData?.title
                        )}
                      </td>
                    );
                  } else if (header?.value == "description") {
                    return (
                      <td className="text-left" style={{ minWidth: "200px" }}>
                        {helpModuleData?.description}
                      </td>
                    );
                  }  
                  else if (header?.value == "created_by") {
                    return (
                      <td className="text-left">
                        <div
                          className="ml-2"
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            gap: "7px",
                          }}
                        >
                          <CircularAvatar
                            name={`${helpModuleData?.updated_by?.first_name} ${helpModuleData?.updated_by?.last_name} `}
                            image={
                              helpModuleData?.profile_pic &&
                              helpModuleData?.profile_pic?.file_url
                            }
                          />
                          <div
                          >
                            <span>
                              {helpModuleData?.updated_by?.first_name}{" "}
                              {helpModuleData?.updated_by?.last_name}{" "}
                            </span>
                              
                            <p style={{color:"#6e7491"}}>{formateDateTime(helpModuleData?.updated_at )}
                          </p>
                          </div>
                        </div>
                      </td>
                    );
                  } else if (header?.value == "attachments") {
                    return helpModuleData?.attachments?.length ? (
                      <td 
                      className="position-relative">
                        <span className="pointer" onClick={() => {handleOpenPreview(helpModuleData)
                            }}>
                        <PaperClipIcon />
                        <span className="badge count-badge">
                          {helpModuleData?.attachments?.length}
                        </span>
                        </span>
                      </td>
                    ) : (
                      <td> --/-- </td>
                    );
                  } else if (header?.value == "video_link") {
                    return (
                      <td className="text-left">
                        {helpModuleData?.video_link[0]?.length > 15 ? (
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 250 }}
                            overlay={
                              <Tooltip id="button-view">
                                {/* {helpModuleData?.video_link} */}
                                <a
                                  href={helpModuleData?.video_link}
                                  target="_blank"
                                >
                                  {helpModuleData?.video_link}
                                </a>
                              </Tooltip>
                            }
                          >
                            <span>
                              {
                                <a
                                  style={{
                                    textDecoration: "underline",
                                    fontWeight: "600",
                                    color: "#262a44",
                                  }}
                                  href={helpModuleData?.video_link}
                                  target="_blank"
                                >
                                  {helpModuleData?.video_link[0]
                                    .toLowerCase()
                                    ?.substr(0, 23) +
                                    (helpModuleData?.video_link &&
                                    helpModuleData?.video_link[0]?.length > 15
                                      ? "..."
                                      : "")}
                                </a>
                              }
                            </span>
                          </OverlayTrigger>
                        ) : (
                          <a
                            style={{
                              textDecoration: "underline",
                              fontWeight: "600",
                              color: "#262a44",
                            }}
                            href={helpModuleData?.video_link}
                            target="_blank"
                          >
                            {helpModuleData?.video_link}
                          </a>
                        )}
                      </td>
                    );
                  }

                  return null;
                })}
                {    isEditHelpDetailsPresent && 
              <td style={{ width: "50px", textAlign: "start" }}>
                <div className="d-flex">
              
                  
                    <span
                      className="d-inline-block pointer"
                      onClick={() => handleEditHelpModule(helpModuleData)}
                    >
                      <div
                        style={{
                          color: "#d43",
                          fontSize: 20,
                          width: "30px",
                        }}
                      >
                        <img src={tableEditIcon} alt="" />
                      </div>
                    </span>
                  
      
                </div>
              </td>}
            </tr>
          );
        })}
    </>
  );
};

export default HelpModuleTable;
